(function () {
  'use strict';

  angular
    .module('sempraWebapp')
    .controller('UserOrganizationController', userOrganizationController);

  /** @ngInject */
  function userOrganizationController(
    organizationActions,
    userRolesEnum,
    $stateParams,
    layoutActions,
    $state,
    userActions,
    brand
  ) {
    var vm = this;
    vm.selectedOrganization = '';
    vm.selectedRole = '';
    vm.selectedUser = '';
    vm.selectedRegion = '';
    vm.userRoles =
      brand === 'karcher'
        ? [
            userRolesEnum.MERCHANT_ADMIN,
            userRolesEnum.FACILITY_ADMIN,
            userRolesEnum.ADMINISTRATOR,
            userRolesEnum.TECHNICAL_SUPPORT,
            userRolesEnum.CONTROLLER,
            userRolesEnum.CASHIER
          ]
        : [userRolesEnum.MERCHANT_ADMIN, userRolesEnum.FACILITY_ADMIN];
    vm.regionList = [];
    vm.organizationListForAvailableUsers = [];
    vm.editMode = false;
    vm.isSystemAdministrator = false;
    vm.isSubscriber = false;

    init();

    function init() {
      vm.editMode = $stateParams.userId;
      refresh();
    }

    vm.saveNewOrganizationUser = function () {
      layoutActions.showLoader();
      var data = {
        firstName: vm.firstName,
        lastName: vm.lastName,
        email: vm.selectedUser,
        roles: [vm.selectedRole],
        regionId: parseInt(vm.selectedRegion),
        organizations: [
          {
            id: parseInt(vm.selectedOrganization)
          }
        ],
        originApp: brand.toUpperCase(),
        verified: vm.editMode ? vm.verified : false
      };

      !vm.editMode
        ? organizationActions
            .createUserForSelectedOrganizationAndRole(data)
            .then(function () {
              layoutActions.hideLoader();
              $state.go('app.accountManagement');
            })
        : organizationActions
            .updateUserForSelectedOrganizationAndRole($stateParams.userId, data)
            .then(function () {
              layoutActions.hideLoader();
              $state.go('app.accountManagement');
            });
    };

    function mapUserRoles(rolesList) {
      rolesList.forEach(function (role) {
        switch (role) {
          case userRolesEnum.SYSTEM_ADMIN:
            vm.isSystemAdministrator = true;
            break;
          case userRolesEnum.SUBSCRIBER:
            vm.isSubscriber = true;
            break;
          case userRolesEnum.CONSUMER:
            vm.isSubscriber = true;
            break;
          default:
            vm.selectedRole = role;
            break;
        }
      });
    }

    function refresh() {
      layoutActions.showLoader();
      organizationActions
        .getForUserOrganizationListByUserId()
        .then(function (response) {
          vm.organizationListForAvailableUsers = response;
          if (vm.editMode) {
            userActions
              .getOrganizationUserById($stateParams.userId)
              .then(function (response) {
                vm.selectedOrganization = response.organizations[0].id;
                vm.selectedRole = response.role;
                vm.selectedUser = response.email;
                vm.selectedRegion = response.regionId;
                vm.firstName = response.firstName;
                vm.lastName = response.lastName;
                mapUserRoles(response.roles);
                vm.verified = response.verified;
              });
          }
          layoutActions.hideLoader();
        });
      organizationActions.getAllRegionsShort().then(function (regionList) {
        vm.regionList = regionList;
        layoutActions.hideLoader();
      });
    }
  }
})();
